<template>
    <section class="form__item__input input">
        <input style="display: none;" type="text" class="input__field" value="" v-model="value" />
        <a v-if="!place_finder_shown" class="window__button button button--primary" @click="launchPlaceFinder()">Launch Place Finder</a>
    </section>
</template>

<script>
  import {PlaceEventHandler} from '../../lib/PlaceEventHandler'
  import {injectMapScript} from '../../lib/PlaceEventHandler'

  export default {
    name: 'PlaceInput',
    components: {
    },
    props: ['settings', 'defaultValue'],
    methods: {
      update(value){
        this.$emit('input', value);
      },
      launchPlaceFinder () {
        this.loadChooser()
        this.place_finder_shown = true;
        return false;
      },
      loadChooser () {
        var chooser = document.createElement('div');
        chooser.id = "place-id-finder";

        chooser.innerHTML = '<div style="display: none">' +
          '<input id="pac-input" class="controls" type="text" placeholder="Enter a location">' +
          '<a id="place-close" class="btn btn-danger">Close</a><br>' +
          '</div>' +
          '<div id="map"></div>' +
          '<div id="infowindow-content">' +
          '<span id="place-name" class="title"></span><br>' +
          '<span id="place-address"></span><br>' +
          '<a id="place-choose" class="btn btn-primary">Use This</a><br>' +
          '</div>';

        document.body.appendChild(chooser);
        let data = this;
        fetch('https://red.broadstreetads.com/me')
          .then(response => {
            response.json().then((d) => {
              data.initMap({
                location: d.location,
                callback: function(placeID) {
                  if (placeID) {
                    data.value = placeID;
                  }
                  document.body.removeChild(chooser);
                  data.closePlaceFinder();
                },
                place_id: data.value
              });
            })
          })
      },
      initMap (opts) {
        var origin = {lat: opts.location.latitude, lng: opts.location.longitude};
        var map = new google.maps.Map(document.getElementById('map'), {
          center: origin,
          zoom: 13
        });

        // We use this class so we can handle the click and the autocomplete without repeating code
        var placeHandler = new PlaceEventHandler(map, origin, opts);

        var close = document.getElementById('place-close');
        map.controls[google.maps.ControlPosition.TOP_LEFT].push(close);

        close.addEventListener('click', function () {
          opts.callback();
        });
      },
      closePlaceFinder () {
        this.place_finder_shown = false;
      }
    },
    data(){
      return {
        value: this.defaultValue || null,
        place_finder_shown: false
      }
    },
    watch: {
      value(newVal){
        this.update(newVal);
      }
    },
    created () {
      injectMapScript();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/configurator/PlaceInput.vue